import { demoPromoBandBlock } from "@/lib/content-blocks-data";
import { PromoBandSection } from "./promo-band-section";

export function FinalFullBleedCallToAction() {
  return <PromoBandSection block={demoPromoBandBlock} />;
}
